import type { GetViewFormItemsRes } from 'types';

export const getFormItemByIdMap = (usableItems?: GetViewFormItemsRes) => {
  return new Map(usableItems?.viewFormItems?.map((f) => [f.formItemId, f]));
};
